

document.addEventListener('DOMContentLoaded', function() {
	const tabs = document.querySelectorAll(".tab-content-button");
	const tabContents = document.querySelectorAll(".tab-pane-content");

	function deactivateAllTabs() {
		tabs.forEach(tab => tab.classList.remove('active'));
		tabContents.forEach(content => content.classList.remove('active'));
	}

	tabs.forEach(tab => {
		tab.addEventListener('click', function() {
			deactivateAllTabs();
			this.classList.add('active');
			const target = document.getElementById(this.dataset.target);
			target.classList.add('active');
		});
        
	});
      if (tabs.length > 0) {
        tabs[0].click();
      }

});